import { Navigate, Route, Routes } from 'react-router-dom'

import { AppShell } from './components/AppShell'
import { ConsoleRuntime, type ConsoleRuntimeDependencies } from './observability/ConsoleRuntime'
import { serverRoot } from './observability/routing'
import { ConsoleSnapshotProvider } from './observability/ConsoleSnapshotProvider'
import type { ConsoleViewState } from './observability/state'
import { AgentDetail, Agents } from './routes/Agents'
import { ContextView } from './routes/Context'
import { Overview } from './routes/Overview'
import { TaskDetail, Tasks } from './routes/Tasks'

function ConsoleViews({ snapshot, connectionStatus }: ConsoleViewState) {
  const root = serverRoot(snapshot.instance.publicBaseUrl)

  return (
    <ConsoleSnapshotProvider snapshot={snapshot} connectionStatus={connectionStatus}>
      <AppShell>
        <Routes>
          <Route path="/" element={<Navigate to={root} replace />} />
          <Route path={root} element={<Overview />} />
          <Route path={root + '/agents'} element={<Agents />} />
          <Route path={root + '/agents/:agentName'} element={<AgentDetail />} />
          <Route path={root + '/tasks'} element={<Tasks />} />
          <Route path={root + '/tasks/:namespace/:taskId'} element={<TaskDetail />} />
          <Route path={root + '/context'} element={<ContextView />} />
          <Route path="*" element={<Navigate to={root} replace />} />
        </Routes>
      </AppShell>
    </ConsoleSnapshotProvider>
  )
}

export type AppProps = {
  testView?: ConsoleViewState
  runtimeDependencies?: ConsoleRuntimeDependencies
}

export function App({ testView, runtimeDependencies }: AppProps = {}) {
  if (testView) return <ConsoleViews {...testView} />

  return (
    <ConsoleRuntime dependencies={runtimeDependencies}>
      {(state) => <ConsoleViews {...state} />}
    </ConsoleRuntime>
  )
}
